export enum Pace {
  Easy = 'EASY',
  Leisurely = 'LIESURELY',
  Steady = 'STEADY',
  Moderate = 'MODERATE',
  Brisk = 'BRISK',
  Vigorous = 'VIGOROUS',
  Strenuous = 'STRENUOUS',
  SuperStrenuous = 'SUPER_STRENUOUS',
} 